module.exports = __webpack_public_path__ + "static/logo-jsonify-1ea6878864e5ba152aa3549dd9258510.png";